import React, {useEffect, useState} from 'react';
import "./AllEvents.scss";
import {useParams} from "react-router-dom";
import Breadcrumb from "./Breadcrumb/Breadcrumb";
import AllEventsYears from "./AllEventsYears/AllEventsYears";
import AllEventsMonths from "./AllEventsMonths/AllEventsMonths";
import AllEventsDays from "./AllEventsDays/AllEventsDays";
import AllEventsForDay from "./AllEventsForDay/AllEventsForDay";
import AllEventsSingleEvent from "./AllEventsSingleEvent/AllEventsSingleEvent";
import {connect} from "react-redux";
import * as actionCreators from "../../../store/actions/actions";
import UrlManager from "../../../tools/UrlManager";

function AllEvents(props) {
    const { userId, year, month, day, eventId } = useParams();
    const [urlKey, setUrlKey] = useState(0);

    useEffect(() => {
        const handlePopState = () => {
            setUrlKey(prev => prev + 1);
        };
        
        // Listen for both popstate (back/forward) and custom pushstate event
        window.addEventListener('popstate', handlePopState);
        
        // Override pushState to trigger our handler
        const originalPushState = window.history.pushState;
        window.history.pushState = function(...args) {
            originalPushState.apply(window.history, args);
            setUrlKey(prev => prev + 1);
        };
        
        return () => {
            window.removeEventListener('popstate', handlePopState);
            window.history.pushState = originalPushState;
        };
    }, []);

    // Single useEffect to handle all URL param changes and cascade resets
    useEffect(() => {
        // Update year or reset if not present
        if (year) {
            props.onUpdateCurrentNavigationYear(year);
        } else {
            props.onUpdateCurrentNavigationYear(null);
        }

        // Update month or reset if not present (also reset deeper levels)
        if (month && year) {
            props.onUpdateCurrentNavigationMonth(month);
        } else {
            props.onUpdateCurrentNavigationMonth(null);
        }

        // Update day or reset if not present (also reset deeper levels)
        if (day && month && year) {
            props.onUpdateCurrentNavigationDay(day);
        } else {
            props.onUpdateCurrentNavigationDay(null);
        }

        // Update eventId or reset if not present
        if (eventId) {
            const eventDate = UrlManager.getDateFromEventId(eventId);
            props.onUpdateCurrentNavigationYear(eventDate.year);
            props.onUpdateCurrentNavigationMonth(eventDate.month);
            props.onUpdateCurrentNavigationDay(eventDate.day);
            props.onUpdateCurrentNavigationEventId(eventId);
        } else {
            props.onUpdateCurrentNavigationEventId(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, month, day, eventId]);

    // Use Redux state for component visibility to ensure immediate updates
    const showYears = !props.currentNavigationYear;
    const showMonths = props.currentNavigationYear && !props.currentNavigationMonth;
    const showDays = props.currentNavigationYear && props.currentNavigationMonth && !props.currentNavigationDay;
    const showEvents = props.currentNavigationYear && props.currentNavigationMonth && props.currentNavigationDay && !props.currentNavigationEventId;
    const showSingleEvent = props.currentNavigationYear && props.currentNavigationMonth && props.currentNavigationDay && props.currentNavigationEventId;

    return <div>
        <Breadcrumb />
        {/* Show only years when no year is selected */}
        {showYears && <AllEventsYears userId={userId} />}
        
        {/* Show only months when year is selected but no month */}
        {showMonths && <AllEventsMonths userId={userId} />}
        
        {/* Show only days when month is selected but no day */}
        {showDays && <AllEventsDays userId={userId} />}
        
        {/* Show only events for day when day is selected but no event */}
        {showEvents && <AllEventsForDay userId={userId} />}
        
        {/* Show single event when event is selected */}
        {showSingleEvent && <AllEventsSingleEvent userId={userId} />}
    </div>
}

const mapStateToProps = state => {
    return {
        currentNavigationYear: state.eventsData.currentNavigationYear,
        currentNavigationMonth: state.eventsData.currentNavigationMonth,
        currentNavigationDay: state.eventsData.currentNavigationDay,
        currentNavigationEventId: state.eventsData.currentNavigationEventId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateCurrentNavigationYear: (currentNavigationYear) => dispatch(actionCreators.updateNavigationYear(currentNavigationYear)),
        onUpdateCurrentNavigationMonth: (currentNavigationMonth) => dispatch(actionCreators.updateNavigationMonth(currentNavigationMonth)),
        onUpdateCurrentNavigationDay: (currentNavigationDay) => dispatch(actionCreators.updateNavigationDay(currentNavigationDay)),
        onUpdateCurrentNavigationEventId: (currentNavigationEventId) => dispatch(actionCreators.updateNavigationEventId(currentNavigationEventId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AllEvents);
